export const ELIGIBLE_UNSECURED_DEBT_ACCOUNT_TYPES = ['CC', 'CH', 'CO', 'FX', 'LC', 'US'];
